import React, { useState } from 'react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/solid';
import logo from '../assets/citispring-logo.png';

const links = [
  { href: '#features', label: 'Features' },
  { href: '#process', label: 'Process' },
  { href: '#specs', label: 'Specs' },
  { href: '#contact', label: 'Contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="bg-white/80 backdrop-blur-md shadow-sm fixed top-0 left-0 w-full z-50 border-b border-gray-100">
      <div className="max-w-[1600px] mx-auto px-6 py-2 flex justify-between items-center">
        <img src={logo} alt="Citispring Logo" className="h-14 md:h-20 object-contain" />

        <div className="hidden md:flex items-center space-x-8">
          {links.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              className="relative text-gray-600 font-medium hover:text-teal-700 transition-colors duration-200 group"
            >
              {label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-teal-600 transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-gray-700 p-1"
          aria-label="Toggle menu"
        >
          {open ? <XMarkIcon className="h-7 w-7" /> : <Bars3Icon className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col space-y-4">
          {links.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              onClick={() => setOpen(false)}
              className="text-gray-600 font-medium hover:text-teal-700 transition-colors"
            >
              {label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
